import React from 'react'

import { APP_LOGO_PATH } from '@flowwai-frontend/bps-officer-web/common/ui'
import {
   FollowLinkedinIcon,
   FollowTwitterIcon,
   FollowWhatsappIcon,
   FollowYoutubeIcon
} from '@flowwai-frontend/design-system/icons'
import { MOBILE_VIEW_BASE_URL_PREFIX } from '@flowwai-frontend/shared/constants'

export const socialMediasDetailsList = [
   {
      id: 'TWITTER',
      navigationLink: 'https://twitter.com/letsflowwai',
      icon: () => <FollowTwitterIcon />
   },
   {
      id: 'LINKEDIN',
      navigationLink: 'https://www.linkedin.com/company/flowwai',
      icon: () => <FollowLinkedinIcon />
   },
   {
      id: 'YOUTUBE',
      navigationLink: 'https://www.youtube.com/@letsflowwai',
      icon: () => <FollowYoutubeIcon />
   },
   {
      id: 'WHATSAPP',
      navigationLink:
         'https://api.whatsapp.com/send/?phone=918584067786&text&type=phone_number&app_absent=0',
      icon: () => <FollowWhatsappIcon />
   }
]

export const imageURLs = {
   APP_LOGO: APP_LOGO_PATH,

   WEB_PAGE: `${MOBILE_VIEW_BASE_URL_PREFIX}/images/web-page-mobile-view.png`,

   GOOGLE_PLAY_IMG_LINK: `${MOBILE_VIEW_BASE_URL_PREFIX}/icons/mobile-google-play-store-icon.svg`,

   GOOGLE_PLAY_NAVIGATION_LINK:
      'https://play.google.com/store/apps/details?id=ai.floww.crm&pli=1'
}

export const MAX_SCREEN_SIZE = 480

export const MOBILE_VIEW_SUPPORTED_BG_IMAGE_URL = `${MOBILE_VIEW_BASE_URL_PREFIX}/icons/mobile-view-supported-bg-image.svg`
